import { DROPDOWN_DEFAULT_VALUE, FIELD_TYPES } from '../../../../utility/constants'
import { getTimeInMillis } from '../../../../utility/datetime'
import { getDefaultValueForField } from '../../utils/fieldUtil'
import { getFieldId, getLegacySubfieldId, getTableFieldId, getTableRowId } from '../../utils/utils'

export const getSubfieldDefaultValue = (subfield, index) => {
  let value = null
  if (subfield?.default_value?.is_same_value) {
    value =
      subfield.data_structure === FIELD_TYPES.LIST_MULTI
        ? subfield?.default_value?.values?.length > 0
          ? subfield?.default_value?.values[0].split(',').map((it) => Number(it))
          : DROPDOWN_DEFAULT_VALUE
        : subfield?.default_value?.values[0]
  } else {
    value =
      subfield.data_structure === FIELD_TYPES.LIST_MULTI
        ? subfield?.default_value?.values?.length > index
          ? subfield?.default_value?.values[index].split(',').map((it) => Number(it))
          : DROPDOWN_DEFAULT_VALUE
        : subfield?.default_value?.values[index]
  }
  return value
}

export const getDefaultValueAsPerDBDefaultValue = (tableFieldId, tableSubfields) => {
  const rowsAsPerDefaultValues = tableSubfields.reduce((acc, cur) => {
    const minRows = cur.default_value?.is_same_value ? 0 : cur.default_value?.values?.length || 0
    return acc > minRows ? acc : minRows
  }, 1)

  let tableDataAsPerDefaultValues = {
    [getFieldId(tableFieldId)]: Math.max(rowsAsPerDefaultValues),
  }

  let tabularData = { updatedAt: getTimeInMillis() }

  const allRows = Array.from({ length: rowsAsPerDefaultValues }, (_, i) => i + 1)

  const tableSequence = []

  // create table subfield's data based on rows and subfields
  allRows.forEach((row, index) => {
    tableSequence.push({ row: row, is_header: false, header_value: '' })

    let rowWiseData = {}
    tableSubfields.forEach((subfield) => {
      const dv = subfield.default_value
        ? getSubfieldDefaultValue(subfield, index)
        : getDefaultValueForField(subfield)

      // generating legacy key-value pair
      tableDataAsPerDefaultValues = {
        ...tableDataAsPerDefaultValues,
        [getLegacySubfieldId(subfield.subfield_template_id, row)]: dv,
      }

      // generating tabular data
      rowWiseData = { ...rowWiseData, [getFieldId(subfield.subfield_template_id)]: dv }
    })

    tabularData[getTableRowId(row)] = { ...rowWiseData, updatedAt: getTimeInMillis() }
  })

  const data = { ...tableDataAsPerDefaultValues, [getTableFieldId(tableFieldId)]: tabularData }
  return { data, sequence: tableSequence }
}
